import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useInventoryReportQuery } from '../../../../Store/Apis/reportApi';
import Error from '../../../../Components/Error/Error';
import Loader from '../../../../Components/Loader/Loader';
import formatDate from '../../../../Hooks/formatDate';

const PrintInventoryReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');

    const { data: Report, isSuccess, isLoading, isFetching, isError } = useInventoryReportQuery({
        startDate,
        endDate,
    }, { skip: !startDate })



     useEffect(() => {
            const sidebar = document.querySelector('aside.sidenav');
            const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
            const navbar = document.querySelector('.navbar-main');
          
            if (sidebar) sidebar.style.display = 'none';
            if (mainContent) mainContent.style.marginLeft = '0';
            if (navbar) navbar.style.display = 'none';
          }, []);

    useEffect(() => {
        if (isSuccess) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [isSuccess, window]);

    if (!isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body p-0">
                <div className="page-wrapper" style={{ padding: 36 }}>
                    {isError && <Error />}
                    {(isLoading || isFetching) && <Loader height="300px" />}
                    {(!isLoading && !isFetching) && (
                        <>
                            <table className='table table-borderless align-items-center mb-3 table-sm border-0'>
                                <tbody>
                                    <tr>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>Start Date</p>
                                            {formatDate(startDate)}
                                        </td>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>End Date</p>
                                            {formatDate(endDate)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="mb-4">
                                <table className="table table-sm table-bordered align-items-center mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 40}}>Sl No.</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 100}}>Service Name</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 100}}>Stock Item</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 60}}>Opening Balance</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 60}}>Quantity Received</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 60}}>Quantity Issued</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 60}}>Closing Balance</th>
                                            <th className='text-sm text-dark text-wrap px-2' style={{maxWidth: 60}}>Re-order Level</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Report.data.length > 0 ? Report.data.map((elem, i) => (
                                            <tr key={i}>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 40}}>{i + 1}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 100}}>{elem.parentName}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 100}}>{elem.serviceTypeName}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 60}}>{elem.openingBalance}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 60}}>{elem.quantityReceived}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 60}}>{elem.quantityIssued}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 60}}>{elem.closingBalance}</td>
                                                <td className='text-sm px-2 text-wrap' style={{maxWidth: 60}}>{elem.reorderLevel}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={7} className="text-center py-5">No Data Found !!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PrintInventoryReport;
